<template>
  <v-app :dark="isDark">
    <div v-if="$auth.ready()">
      <router-view></router-view>
    </div>

    <div v-if="!$auth.ready()">
      Loading ...
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      isDark: false
    }
  },
  mounted () {
    this.$root.$on('lights-switch', this.switchLights)

  },
  methods: {
    switchLights: function () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      this.isDark = !this.isDark
    }
  },
  created () {
    this.$auth.ready(function () {
      if (this.$auth.user().is_temp) {
        this.$notify.warn('Please change your password!')
      }
    })
  }
}
</script>
